import React, { useEffect } from "react";
import { Icon, IconButton, Tooltip } from "@material-ui/core";
import MaterialTable, { MTableAction } from "material-table";

var actionTypes = { UPDATE: "UPDATE", DELETE: "DELETE", NEW: "NEW" };

function ActionWithMiddleClick(props) {
  let action = props.action;

  if (typeof action === "function") {
    action = action(props.data);
    if (!action) return null;
  }

  if (action.action) {
    action = action.action(props.data);
    if (!action) return null;
  }

  if (action.hidden) return null;
  if (!action.onMiddleClick) return <MTableAction {...props} action={action} />;

  const disabled = action.disabled || props.disabled;

  const handleOnClick = (event) => {
    if (action.onClick) {
      action.onClick(event, props.data);
      event.stopPropagation();
    }
  };

  const handleOnMouseDown = (event) => {
    if (event.button === 1 && !disabled) {
      event.preventDefault();
      action.onMiddleClick(event, props.data);
      event.stopPropagation();
    }
  };

  const icon =
    typeof action.icon === "string" ? (
      <Icon {...action.iconProps}>{action.icon}</Icon>
    ) : typeof action.icon === "function" ? (
      action.icon({ ...action.iconProps, disabled })
    ) : (
      React.createElement(action.icon, null)
    );

  const button = (
    <IconButton size={props.size} color="inherit" disabled={disabled} onClick={handleOnClick} onMouseDown={handleOnMouseDown}>
      {icon}
    </IconButton>
  );

  return action.tooltip ? <Tooltip title={action.tooltip}>{disabled ? <span>{button}</span> : button}</Tooltip> : button;
}


export default function MaterialTableComponent(props) {
  const { options, parentChildData, data, columns } = props;
  const [state, setState] = React.useState({
    columns: props.columns.map((column) => {
      //Do not remove - props.columns.map needed to fix material-table bug! columns must be declared in this component, if removed material-table will freeze the page after 3 searches
      //if encounter any other page freezes on a page with a table - try to declare a new var instead of using the prop directly and to use map on the object/array and copy it to a new one
      return { ...column };
    }),
    data: props.data.map((row) => {
      //Do not remove - see comment on props.columns.map above
      return { ...row };
    })
  });

  useEffect(() => {
    //see comment above on state useState hook
    setState({
      columns: columns.map((column) => {
        return { ...column };
      }),
      data: data.map((row) => {
        return { ...row };
      })
    });
  }, [data, columns]);

  return (
    <MaterialTable
      title={props.tableTitle}
      columns={state.columns}
      data={state.data}
      options={options ? options : {}}
      parentChildData={parentChildData ? parentChildData : null}
      components={props.enableRedirectMiddleClick ? { Action: ActionWithMiddleClick } : undefined}
      localization={{
        pagination: {
          labelDisplayedRows: "{from}-{to} מתוך {count}",
          labelRowsSelect: "כמות רשומות",
          firstTooltip: "עמוד ראשון",
          lastTooltip: "עמוד אחרון",
          nextTooltip: "עמוד הבא",
          previousTooltip: "עמוד קודם"
        },
        toolbar: {
          nRowsSelected: "{0} row(s) selected",
          searchPlaceholder: "חיפוש"
        },
        header: {
          actions: ""
        },
        body: {
          emptyDataSourceMessage: props.noRecordsYetMsg || "No records to display",
          filterRow: {
            filterTooltip: "Filter"
          },
          addTooltip: "הוסף",
          editRow: { deleteText: "למחוק?" }
        }
      }}
      // localization={{ body: { editRow: { deleteText: "Customized Delete Message" } } }}
      actions={[
        (rowData) => {
          return props.onInitComments
            ? {
                icon: "comments",
                tooltip: "הערות",
                onClick: (event, rowData) => {
                  // props.redirectToSpecificUser(rowData);
                  props.onInitComments(event, rowData);
                }
              }
            : null;
        },
        (rowData) => {
          return props.redirectToSpecificUser
            ? {
                icon: "exit_to_app",
                tooltip: "כניסה לעסקה",
                //dont show on a user's child-member
                hidden: props.hideRedirectToSpecificUserOnMemberRow && !!rowData.belongToCardNum,
                onClick: (event, rowData) => {
                  props.redirectToSpecificUser(rowData, event);
                },
                onMiddleClick: props.enableRedirectMiddleClick
                  ? (event, rowData) => {
                      props.redirectToSpecificUser(rowData, event);
                    }
                  : null
              }
            : null;
        }
      ]}
      editable={{
        isEditHidden: (rowData) => !!rowData.belongToCardNum, //user's children members are not editable - hide edit button
        onRowAdd: (newData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              props.onDataChanged(newData, actionTypes.NEW).then(
                (newId) => {
                  resolve();
                  setState((prevState) => {
                    const data = [...prevState.data];
                    if (newId) newData["_id"] = newId;
                    data.push(newData);
                    return { ...prevState, data };
                  });
                },
                () => {
                  resolve();
                }
              );
            }, 600);
          }),

        onRowUpdate: props.onDataChanged
          ? (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  if (oldData) {
                    props.onDataChanged(newData, actionTypes.UPDATE).then(
                      () => {
                        resolve();
                        setState((prevState) => {
                          const data = [...prevState.data];
                          data[data.indexOf(oldData)] = newData;
                          return { ...prevState, data };
                        });
                      },
                      () => {
                        resolve();
                      }
                    );
                  }
                }, 600);
              })
          : null,

        onRowDelete: props.onInitComments
          ? (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  props.onDataChanged(oldData, actionTypes.DELETE).then(
                    () => {
                      resolve();
                      setState((prevState) => {
                        const data = [...prevState.data];
                        data.splice(data.indexOf(oldData), 1);
                        return { ...prevState, data };
                      });
                    },
                    () => {
                      resolve();
                    }
                  );
                }, 600);
              })
          : null
      }}
    />
  );
}
